import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
	children: ReactNode;
	fallbackMessage?: string;
}

interface State {
	hasError: boolean;
	error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false,
		error: undefined,
	};

	public static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error("Uncaught error in ErrorBoundary:", error, errorInfo);
	}

	public render() {
		if (this.state.hasError) {
			return (
				<div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded">
					<h2 className="text-lg font-semibold">
						{this.props.fallbackMessage || "Quelque chose s'est mal passé."}
					</h2>
					{this.state.error && (
						<p className="mt-2 text-sm">{this.state.error.toString()}</p>
					)}
					<p className="mt-1 text-sm">
						Veuillez essayer de rafraîchir la page ou contactez le support si le
						problème persiste.
					</p>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
